import { createContext, useContext } from "react";

import type { Group } from "@/schemas";

interface GroupContextValue {
  group: Group;
  groupId: string;
}

const GroupContext = createContext<GroupContextValue | null>(null);

function useGroupContext(): GroupContextValue {
  const ctx = useContext(GroupContext);
  if (!ctx) throw new Error("useGroupContext must be used within GroupGuard");
  return ctx;
}

export { GroupContext, useGroupContext };
